export const UPS_BASE_URL = "https://ups.data.cbc.ca/v0";
